var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 3.33334C28.9921 3.33334 20.0002 12.3287 20.0002 23.3333V26.6667C16.3168 26.6667 13.3335 29.6533 13.3335 33.3333V66.6667C13.3335 70.3467 16.3168 73.3333 20.0002 73.3333H60.0002C63.6835 73.3333 66.6668 70.3467 66.6668 66.6667V33.3333C66.6668 29.6533 63.6835 26.6667 60.0002 26.6667V23.3333C60.0002 12.3279 51.0056 3.33334 40.0002 3.33334ZM40.0002 10C47.4014 10 53.3335 15.9321 53.3335 23.3333V26.6667H26.6668V23.3333C26.6668 15.9313 32.5949 10 40.0002 10ZM39.896 33.2292C49.8793 33.2292 50.0002 40.67 50.0002 42.0833C49.9968 49.53 41.8785 49.9417 42.2918 56.4583H36.4585C35.9685 47.7217 43.4377 47.3258 43.4377 42.3958C43.4377 38.8525 41.056 38.5417 39.896 38.5417C36.426 38.5417 36.2635 41.8233 36.2502 42.5H29.6877C29.7043 40.92 30.0327 33.2292 39.896 33.2292ZM39.4793 59.8958C42.7827 59.8958 43.1252 62.9408 43.1252 63.4375C43.1252 63.9175 42.7827 66.875 39.4793 66.875C36.056 66.875 35.8335 63.9175 35.8335 63.4375C35.8335 62.9408 36.1227 59.8958 39.4793 59.8958Z",
    fill: "#EE3138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordIcon);
export default __webpack_public_path__ + "static/media/forgot_password_icon.a6d7af4fb02f119108e23ca26ec58746.svg";
export { ForwardRef as ReactComponent };